import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { orderMeetingSend, clearMeeting, closeMeetingEdit, openErrorMsg, closeErrorMsg, getSchedule, resetStore } from "../../redux/modules/meeting";
import { loadAgentsList } from "../../redux/modules/agents";
import InputField from "../common/input-field"
import SelectField from "../common/select-field"
import TextareaField from "../common/textarea-field"
import { useForm } from "../../hooks/use-form";
import Layout from "../layout"
import Managers from '../Contacts/managers';
import Calendar from './calendar';
import PopupSuccess from './popup-success'
import PopupCancel from './popup-cancel'
import PopupMsg from '../common/popup-msg'
import { checkClient, checkingClient, clearCheck, resetCheckStore } from '../../redux/modules/check-client';
import moment from 'moment';

const Form = ({eventTypeId, edit}) => {
  const navigate = useNavigate();
  const location = useLocation()
  const dispatch = useDispatch();
  const ref = useRef();

  const auth = useSelector(state => state.auth);
  const check = useSelector(state => state.checkclient.check);
  const checked = useSelector(state => state.checkclient.checked);
  const checking = useSelector(state => state.checkclient.loading);
  
  const projects = useSelector(state => state.realty.projects);
  const types = useSelector(state => state.realty.types);
  const agents = useSelector(state => state.agents.response);

  const meeting = useSelector(state => state.meeting);
  const managers = useSelector(state => state.meeting.managers);
  const schedule = useSelector(state => state.meeting.schedule);
  const editdata = useSelector(state => state.meeting.edit);
  const mobile = useSelector(state => state.mobile);

  const [active, setActive] = useState(0);
  const [manager, setManager] = useState(editdata ? {id: editdata.managerId, name: editdata.manager} : '');  
  const [selectedDate, setSelectedDate] = useState(editdata ? new Date(editdata.timeslot.split(" ")[0].split(".").reverse().join("-")) : null);
  const [selectedTime, setSelectedTime] = useState(editdata && schedule ? schedule[editdata.managerId].filter((el) =>  el.id === editdata.timeslotId )[0] : null);
  const [cancel, setCancel] = useState(false);
  const [visibleerrors, setVisibleErrors] = useState(false);
  const [full, setFull] = useState(false);

  const [fields, setValue, setFieldValid, formIsValid, trigger, setTrigger, setValidate, setCheckValue, setAddress, setInn, setValueSelect, clearForm, ] = useForm({
    phone: {
      value: editdata ? editdata.clientPhone : (location.state ? location.state.phone : ''),
      name: 'phone',
      type: 'tel',
      label: 'Телефон *',
      validate: 'phone',
      valid: edit || location || (!edit && eventTypeId == 2 ) ? true : false,
      valid_reg: edit || location || (!edit && eventTypeId == 2 ) ? true : false,
    },
    name: {
      value: editdata ? editdata.clientName : '',
      name: 'name',
      type: 'text',
      label: 'Имя *',
      validate: 'text',
      valid: edit || (!edit && eventTypeId == 2 ) ? true : false,
      valid_reg: edit || (!edit && eventTypeId == 2 ) ? true : false,
    },
    project: {
      value: editdata ? { value: editdata.projectId, label: editdata.project } : '',
      name: 'project',
      type: 'select',
      label: 'Проект *',
      validate: 'text',
      valid: edit ? true : false,
      valid_reg: edit ? true : false,
    },
    property: {
      value: editdata ? { value: editdata.typeId, label: editdata.type } : '',
      name: 'property',
      type: 'select',
      label: 'Тип недвижимости *',
      validate: 'text',
      valid: edit ? true : false,
      valid_reg: edit ? true : false,
    },
    broker: {
      value: editdata ? { value: editdata.brockerId, label: editdata.brocker } : '',
      name: 'broker',
      type: 'select',
      label: eventTypeId == 1 ? 'Брокер *' : 'Контактное лицо *',
      validate: 'text',
      valid: edit || auth.user.group !== 'lead' ? true : true,
      valid_reg: edit || auth.user.group !== 'lead' ? true : true
    },
    persons: {
      value: editdata ? editdata.clientsNumber : '',
      name: 'persons',
      type: 'tel',
      label: 'Количество человек *',
      validate: 'number',
      valid: edit || (!edit && eventTypeId == 1 ) ? true : false,
      valid_reg: edit || (!edit && eventTypeId == 1 ) ? true : false,
    },
    note: {
      value: '',
      name: 'note',
      type: 'textarea',
      label: 'Примечание',
      placeholder: 'Примечание',
      valid: true,
    },
    meettype: {
      value: editdata ? editdata.formatId : '',
      name: 'type',
      validate: 'radio',
      valid: edit ? true : false,
      valid_reg: edit ? true : false,
    },
  }, []);
  
  useEffect(() => {    
    if(!agents) {
      dispatch(
        loadAgentsList({
          cmd: 'agents-list',
          _debug_token: auth.token
        }))
    }
    if(editdata) {
      dispatch(
        getSchedule({
          cmd: 'orders-getschedule',
          eventTypeId: editdata.eventTypeId,
          formatId: editdata.formatId,
          _debug_token: auth.token
        })
      )
    }
    if(location) setCheckClient();
    
    return () => {      
      dispatch(resetStore());
      dispatch(clearCheck());
    }

  }, []);

  
  useEffect(() => {    
    clearForm();
  }, [location]);

  const handleSubmit = (e) => {
    e.preventDefault();    

    if(!manager || !selectedTime) dispatch(openErrorMsg({error: 'Выберите менеджера, а затем дату и время встречи'}))

    if (formIsValid() && manager && selectedTime) {
      dispatch(
        orderMeetingSend({
          cmd: edit ? 'orders-edit' : 'orders-add',
          id: editdata ? editdata.id : '',
          clientName: fields.name.value,
          clientPhone: fields.phone.value.replace(/[^0-9]/g, ''),
          clientsNumber: fields.persons.value,
          projectId: fields.project.value.value,
          typeId: fields.property.value.value,
          comment: fields.note.value,
          managerId: manager.id,
          eventTypeId: eventTypeId,
          formatId: fields.meettype.value,
          brockerId: fields.broker.value.value,
          timeslotId: selectedTime.id,
          _debug_token: auth.token
        })
      ).then((response) => {
        console.log(response)
        //console.log(schedule[manager.id])
        //if(meeting.success) schedule[manager.id].map((item) => item.id === selectedTime.id ? item.enabled = false : '' )
        
        //if(edit) dispatch(clearCheck());
      })     
    } 
  }

  const nextStep = (e) => {
    if(e) e.preventDefault();  

    if (formIsValid()) {
      dispatch(
        getSchedule({
          cmd: 'orders-getschedule',
          eventTypeId: eventTypeId,
          formatId: fields.meettype.value,
          _debug_token: auth.token
        })
      ).then((responses) => {
        setActive(1);
        document.querySelector('.page__content').scrollTo(0, 0) 
      })
    } else {
      setVisibleErrors(true);
    }
  }

  const handleClick = e => {
    if ((formIsValid() && managers) || edit) {
      const index = parseInt(e.target.id, 0);
      if (index !== active) {
        if(index == 1) nextStep();
        setActive(index);
      }
    }
  };

  const handleClose = () => {
    dispatch(
        getSchedule({
        cmd: 'orders-getschedule',
        eventTypeId: eventTypeId,
        formatId: fields.meettype.value,
        _debug_token: auth.token
      })
    )
    dispatch(closeErrorMsg());
  };

  const changeRadio = (value) => {
    setCheckValue('meettype', value, true, true);
  }

  const chooseManager = (value) => {
    setManager(!manager || manager.id !== value.id ? value : '');
  }

  const closePopup = () => {
    setCancel(!cancel)
  }

  const clearMeet = () => {
    dispatch(clearMeeting());
    clearForm();
    setManager('');
    setSelectedTime(null);
    setActive(0);
    setCancel(false);
    setVisibleErrors(false);
    document.querySelector('.page__content').scrollTo(0, 0) 
    if(edit) {
      dispatch(closeMeetingEdit());
    }
    if(eventTypeId == 1) {
      dispatch(clearCheck());
      navigate(location.pathname, { });
    }
  }

  const cancelEdit = () => {
    //navigate(eventTypeId == 1 ? '/meetings' : '/broker-tours')
    //navigate(location.state.back + location.state.hash, {state: {hash: location.state.hash.split('#')[1]} })
    dispatch(closeMeetingEdit());
  }

  const setCheckClient = () => {
    if(fields.phone.value.length == 16) {
      dispatch(checkingClient())
    } else {
      dispatch(clearCheck());
    }
  }

  const handleCheckClient = () => {
    if(fields.phone.value.length == 16) {
      if(!full) {
        setFull(true);
        dispatch(
          checkClient({
            cmd: 'clients-check',
            phone: fields.phone.value.replace(/[^0-9]/g, ''),
            _debug_token: auth.token
          })
        )
      }
    } else {
      setFull(false);
      dispatch(clearCheck());
    }
  }

  const createSlotsList = () => {

    let list = []
    //let date = selectedDate.toISOString().split('T')[0]

    //for(let manager in schedule) {

      if(fields.meettype.value) {
        for(let manager in schedule) {
          schedule[manager].map((item) => {
            list.push(item)
          })          
        }
      }
    //}
    console.log(list)
    const uniqueArr = list && list.filter((obj, idx, arr) => idx === arr.findIndex((t) =>  t.date === obj.date && t.period === obj.period)).sort((a, b) => a.period > b.period ? 1 : -1)
    
    return uniqueArr
  }

  const createTypesSelect = () => {
    let arr = managers.map((it) => it.typeId )
    let array = types.filter((i, key) => {
      return arr.filter((item, index) => {
        return arr.indexOf(item) === index
      }).includes(i.id)
    })

    return array.map((item) => ({value: item.id, label: item.name}))
  }

  //console.log('schedule', schedule);
  //console.log('manager.id', manager);
  //console.log('editdata', editdata);

  return (    
    <Layout>
      <div className="page-regist-meeting"> 
        {edit && eventTypeId == 1 && <div className="title title_edit">Редактирование записи на&nbsp;встречу</div>} 
        {edit && eventTypeId == 2 && <div className="title title_edit">Редактирование записи <nobr>на&nbsp;брокер-тур</nobr></div>} 
        <div className="tabs">
          <div className="tabs__wrap">
            <div className="tabs__item" onClick={handleClick} data-active={active === 0} data-touch={active !== 0} id={0}>{!mobile && 'Информация '}о проекте</div>
            <div className="tabs__item" onClick={handleClick} data-active={active === 1} data-touch={active !== 1 && formIsValid()} id={1}>Дата и время</div>
          </div>        
        </div>        
        <form className="form fadeIn" onSubmit={handleSubmit}>       
          <div className="tabs-content" data-active={active === 0}>
            <div className="form__columns">
              <div className="form__column">
                <div className="title">{eventTypeId == 1 ? 'данные о клиенте' : 'данные'}</div>
                {eventTypeId == 1 && (
                  <>
                    <InputField
                      ref={ref}
                      trigger={trigger}
                      setFieldValid={setFieldValid}
                      setValue={setValue}
                      disable={edit || (!edit && eventTypeId == 2 && checking )}
                      status={check}
                      keyUp={handleCheckClient}
                      checkresult={check !== null ? (check ? 'Клиент уникальный. Доступно создание встречи' : 'Клиент не уникальный. Создание встречи не доступно.') : ''}
                      {...fields.phone}
                    />
                    <InputField
                      trigger={trigger}
                      setFieldValid={setFieldValid}
                      setValue={setValue}
                      disable={edit || (!edit && eventTypeId == 1 && !check )}
                      {...fields.name}
                    />
                  </>
                )}
                <SelectField
                  trigger={trigger}
                  setFieldValid={setFieldValid}
                  setValueSelect={setValueSelect}
                  disable={edit || (!edit && eventTypeId == 1 && !check )}
                  options={projects ? projects.map((item) => ({value: item.id, label: item.name})) : []}
                  {...fields.project}
                />
                <SelectField
                  trigger={trigger}
                  setFieldValid={setFieldValid}
                  setValueSelect={setValueSelect}
                  disable={edit || (!edit && eventTypeId == 1 && !check )}
                  options={types ? createTypesSelect() : []}
                  
                  {...fields.property}
                />
                {auth.user.group == 'lead' && (
                  <SelectField
                    trigger={trigger}
                    setFieldValid={setFieldValid}
                    setValueSelect={setValueSelect}
                    disable={edit || (!edit && eventTypeId == 1 && !check )}
                    options={editdata ? { value: editdata.brockerId, label: editdata.brocker } : (agents ? agents.map((item) => ({value: item.id, label: item.fio })) : [])}                    
                    {...fields.broker}
                  />
                )}
                {eventTypeId == 2 && (
                    <InputField
                    trigger={trigger}
                    setFieldValid={setFieldValid}
                    setValue={setValue}
                    disable={edit || (!edit && eventTypeId == 1 && !check )}
                    {...fields.persons}
                    />
                )}
                <TextareaField
                  trigger={trigger}
                  setFieldValid={setFieldValid}
                  setValue={setValue}
                  disable={!edit && eventTypeId == 1 && !check}
                  {...fields.note}
                />
                <div 
                  className="form__comment"
                  data-disable={!edit && eventTypeId == 1 && !check}
                >* Обязательные поля</div>
              </div>
              <div className="form__column">
                <div className="title">формат встречи</div>
                <label 
                  className={fields.meettype.value == '1' ? "radio radio_active" : "radio"}
                  onClick={() => changeRadio('1')}
                  data-valid={fields.meettype.value  ? 'true' : 'false'}
                  data-error={visibleerrors}
                  data-disable={!edit && eventTypeId == 1 && !check}
                >
                  <span className="radio__check"></span>
                  <div className="radio__text">Онлайн</div>
                </label>
                <label 
                  className={fields.meettype.value == '2' ? "radio radio_active" : "radio"}
                  onClick={() => changeRadio('2')}
                  data-valid={fields.meettype.value  ? 'true' : 'false'}
                  data-error={visibleerrors}
                  data-disable={!edit && eventTypeId == 1 && !check}
                >
                  <span className="radio__check"></span>
                  <div className="radio__text">
                    Офис продаж<br/>
                    <span>Москва, Рыбников пер., д. 1 <a href={`https://maps.yandex.ru/?text=55.767493568977,37.632727`} target="_blank">на карте</a></span>
                  </div>
                </label>
              </div>
            </div>
            <div 
              className="form__buttons"
              data-disable={!edit && eventTypeId == 1 && !check}              
            >
              <button type={'submit'} className="btn" onClick={nextStep}>Продолжить</button>
              <button type="button" className="btn btn_empty" onClick={edit ? cancelEdit : closePopup}>{edit ? 'Отменить изменения' : 'Отменить запись'}</button>
            </div>
          </div>
          <div className="tabs-content" data-active={active === 1}>
            <div className="form__columns">
              <div className="form__column">
                <div className="title">Выберите дату и время</div>
                {schedule && <Calendar 
                  //timeboxes={edit ? schedule.filter((item) => new Date(item.date) == new Date(selectedDate.split(" ")[0]) ) : schedule.filter((el) => el.managerId === manager.id )} 
                  timeboxes={manager.id ? schedule[manager.id] : createSlotsList()} 
                  currentdate={selectedDate} 
                  setDate={setSelectedDate} 
                  time={selectedTime} 
                  enable={manager ? true : false}
                  setTime={setSelectedTime} 
                  edittime={editdata ? schedule[editdata.managerId].filter((el) =>  el.id === editdata.timeslotId )[0] : null}
                />}
                {!mobile && (<div 
                  className="form__buttons"
                  data-disable={!edit && eventTypeId == 1 && !check}              
                >
                  <button type={'submit'} className="btn">{edit ? 'Сохранить изменения' : 'Записаться'}</button>
                  <button type="button" className="btn btn_empty" onClick={edit ? cancelEdit : closePopup}>{edit ? 'Отменить изменения' : 'Отменить запись'}</button>
                </div>)}            
              </div>
              <div className="form__column">
                <div className="title">Выберите менеджера</div>
                <Managers 
                  data={managers ? (selectedDate ? managers.filter((el) => el.projectId === fields.project.value.value && el.typeId === fields.property.value.value && schedule && schedule[el.id].filter((item) => item.date === moment(selectedDate).format('DD.MM.YYYY')).length) : managers) : ''} 
                  choose={chooseManager} 
                  active={manager} 
                  photo={true} 
                />

                {mobile && (<div 
                  className="form__buttons"
                  data-disable={!edit && eventTypeId == 1 && !check}              
                >
                  <button type={'submit'} className="btn">{edit ? 'Сохранить изменения' : 'Записаться'}</button>
                  <button type="button" className="btn btn_empty" onClick={edit ? cancelEdit : closePopup}>{edit ? 'Отменить изменения' : 'Отменить запись'}</button>
                </div>)}
              </div>
            </div>
          </div>
        </form>
      </div>
      {meeting.success && <PopupSuccess eventTypeId={eventTypeId} fio={fields.name.value} manager={manager.name} meettype={fields.meettype.value} time={selectedTime} project={fields.project.value.label} close={clearMeet} />}
      {cancel &&  <PopupCancel eventTypeId={eventTypeId} close={closePopup} cancel={clearMeet} />}
      {meeting.error && <PopupMsg message={meeting.error} close={handleClose} />}

    </Layout>
  )
}

export default Form